(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationActionDefinitionDeleteController',CommunicationActionDefinitionDeleteController);

    CommunicationActionDefinitionDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationActionDefinition'];

    function CommunicationActionDefinitionDeleteController($uibModalInstance, entity, CommunicationActionDefinition) {
        var vm = this;

        vm.communicationActionDefinition = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CommunicationActionDefinition.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
